import { MessageModalState, MessageModalInitialState, ReduxAction } from "../models";
import { MessageModalsType } from "../types";

export const MessageModalsState = (state: MessageModalState = MessageModalInitialState, action?: ReduxAction): MessageModalState => {
    if (!action) return state;

    switch (action.type) {
        case MessageModalsType.SET_MESSAGE_MODAL_DATA:
            return { ...action.payload };
        case MessageModalsType.CLEAR_MESSAGE_MODAL_DATA:
            return { ...MessageModalInitialState };
    }

    return state;
};
